import { Box, Tooltip } from '@mui/material';

import { IPhoneNumber, PhoneNumberType } from '@/models';
import { formatPhoneNumber } from '@/utils';

const PHONE_PRIORITY: Record<string, number> = {
  [PhoneNumberType.MOBILE]: 1,
  [PhoneNumberType.HOME]: 2,
  [PhoneNumberType.WORK]: 3,
  [PhoneNumberType.OTHER]: 4,
  [PhoneNumberType.CALLER]: 5,
};

const toLabel = (type: string) => type.charAt(0) + type.slice(1).toLowerCase();

export const PhoneNumbersCell = ({
  phoneNumbers,
}: {
  phoneNumbers?: IPhoneNumber[] | null;
}) => {
  if (!phoneNumbers?.length) return <span>/</span>;

  const sorted = [...phoneNumbers].sort(
    (a, b) => (PHONE_PRIORITY[a.type] ?? 99) - (PHONE_PRIORITY[b.type] ?? 99),
  );

  const [primary, ...rest] = sorted;

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <span>{formatPhoneNumber(primary.phoneNumber)}</span>
      {rest.length > 0 && (
        <Tooltip
          arrow
          slotProps={{
            tooltip: {
              sx: {
                width: '200px',
                radius: '9px',
                py: '12px',
                px: '20px',
                bgcolor: '#0E3145',
                fontSize: '14px',
                fontWeight: 500,
                paragraphSpacing: '6px',
                '& .MuiTooltip-arrow': { color: '#0E3145' },
              },
            },
          }}
          title={
            <Box>
              {rest.map((p) => (
                <div key={p.phoneNumber}>
                  {toLabel(p.type)}: {formatPhoneNumber(p.phoneNumber)}
                </div>
              ))}
            </Box>
          }
        >
          <Box
            component="span"
            sx={{
              bgcolor: '#E7EAEC',
              color: '#0E3145',
              borderRadius: '11px',
              gap: '10px',
              px: '8px',
              fontSize: '12px',
              fontWeight: 500,
              cursor: 'default',
              lineHeight: '17px',
              letterSpacing: '0px',
            }}
          >
            +{rest.length}
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
